import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CommonPipesModule } from '@client/app/shared/common-pipes.module';
import { SharedModule } from '@client/app/shared/shared.module';
import { DsButtonVariants, DsModule } from '@levelaccess/design-system';

@Component({
  selector: 'app-remove-user-modal',
  templateUrl: './remove-user-modal.component.html',
  imports: [DsModule, CommonPipesModule, SharedModule],
  standalone: true,
})
export class RemoveUserModalComponent {
  @Input() willBeRemoved: boolean = false;
  @Input() groupName: string = '';

  protected readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;

  constructor(readonly modal: NgbActiveModal) {}

  protected onConfirm(): void {
    this.modal.close(true);
  }

  protected onCancel(): void {
    this.modal.dismiss(false);
  }
}
